import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter'
})
export class SearchPipePipe implements PipeTransform {

  transform(list: any[], filterField: string, keyword: string): any {
    if (!filterField || !keyword) {
      return list;
    }
    return list.filter((item) => {
      if (item) {
        const val = item[filterField];
        let status: boolean;
        val.indexOf(keyword) >= 0 ? status = true : status = false;
        return status;
      }
    });
  }

}
